import React from 'react';

export default function Payments() {
  return (
    <main className="bg-gray-50 py-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900">Payment Information</h1>
          <p className="mt-4 text-lg text-gray-600">
            You can use the following methods for payments. Please double-check the recipient details before sending.
          </p>
        </div>

        {/* Payment Methods Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Zelle Card */}
          <div className="bg-white rounded-lg shadow-lg p-8 flex flex-col items-center text-center">
            <img src="/images/logo_zelle.png" alt="Zelle" className="h-8 mb-6 object-contain" />
            <div className="w-48 h-48 mb-4 rounded-lg flex items-center justify-center overflow-hidden border border-gray-100">
              <img src="/images/zelle_qr.jpg" alt="Zelle QR Code" className="w-full h-full object-contain" />
            </div>
            <p className="text-gray-700 font-semibold">Associated Email:</p>
            <p className="text-gray-600">sunnysjamil@gmail.com</p>
          </div>

          {/* Venmo Card */}
          <div className="bg-white rounded-lg shadow-lg p-8 flex flex-col items-center text-center">
            <img src="/images/logo_venmo.png" alt="Venmo" className="h-6 mb-6 object-contain" />
            <a
              href="https://venmo.com/u/sunnysjamil"
              target="_blank"
              rel="noreferrer"
              className="flex flex-col items-center hover:opacity-90 transition-opacity"
            >
              <div className="w-48 h-48 mb-4 rounded-lg flex items-center justify-center overflow-hidden border border-gray-100">
                <img src="/images/venmo_qr.jpg" alt="Venmo QR Code" className="w-full h-full object-contain" />
              </div>
              <p className="text-gray-700 font-semibold">Username:</p>
              <p className="text-indigo-600 font-medium hover:underline">@sunnysjamil</p>
            </a>
          </div>
        </div>
      </div>
    </main>
  );
}
